import "core-js/modules/es6.regexp.to-string";
var TOAST_STYLE = "\n    background-color:rgba(0,0,0,0.9);\n    border-radius:5px;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.52);\n    color:#fff;\n    font-size: 14px;\n    opacity:0;\n    padding:16px 20px;\n    position:fixed;\n    left:0;\n    top:0;\n    max-width:80%;\n    -webkit-transition:opacity 0.1s linear;\n    -moz-transition:opacity 0.1s linear;\n    -ms-transition:opacity 0.1s linear;\n    transition:opacity 0.1s linear;\n    word-wrap:break-word;\n    z-index: 9999;\n";

function createElement(content) {
  var $toast = document.createElement('div');
  $toast.id = Math.random().toString(36).substr(2);
  $toast.innerText = content;
  $toast.setAttribute('style', TOAST_STYLE);
  document.body.appendChild($toast);
  setTimeout(function () {
    $toast.style.marginLeft = "".concat(-$toast.offsetWidth / 2, "px");
    $toast.style.marginTop = "".concat(-$toast.offsetHeight / 2, "px");
    $toast.style.left = '50%';
    $toast.style.top = '44%';
    $toast.style.opacity = 1;
  }, 10);
  return $toast;
}

export function toast() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
  var $toast = createElement(content);
  setTimeout(function () {
    $toast.style.opacity = 0;
    setTimeout(function () {
      document.body.removeChild($toast);
      $toast = null;
    }, 100);
  }, duration);
}